// Iter315 · G07 — ayuda contextual: icono "?" con tooltip explicando
// métricas/campos que suelen generar dudas (p.ej. "¿por qué no coincide
// esto con lo otro?"). Reutilizable en cualquier página.
import React from "react";
import { HelpCircle } from "lucide-react";
import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from "@/components/ui/tooltip";

export function HelpTip({ text, className = "" }) {
  return (
    <TooltipProvider>
      <Tooltip delayDuration={150}>
        <TooltipTrigger asChild>
          <button
            type="button"
            tabIndex={0}
            aria-label={`Ayuda: ${text}`}
            data-testid="help-tip-trigger"
            className={`inline-flex items-center justify-center text-gray-300 hover:text-[#007934] focus:text-[#007934] focus:outline-none transition-colors ${className}`}
          >
            <HelpCircle size={13} />
          </button>
        </TooltipTrigger>
        <TooltipContent className="max-w-[260px] text-left bg-gray-900 text-white border-none">
          {text}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

export default HelpTip;
